module.exports = __webpack_public_path__ + "static/media/rd-logo-dark.b2052cf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/rd-logo-dark.png
// module id = 74
// module chunks = 0